import * as React from 'react'
import { User } from '../api/models/user'

const context = React.createContext<User | undefined>(undefined)
export const UserContextProvider = context.Provider
export const UserContextConsumer = context.Consumer
export const UserContextType = context